import { useState, useCallback } from 'react';
import APIRequest from '../../../services/APIRequest';

export default function useSubscriptionDetail() {
  const [subscription, setSubscription] = useState(null);
  const [billingHistory, setBillingHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSubscriptionDetail = useCallback(async (subscriptionId) => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await APIRequest.get(`admin/subscriptions/${subscriptionId}`);
      
      if (response?.ok) {
        const data = response.data?.data;
        if (data) {
          setSubscription(data.subscription);
          setBillingHistory(data.billingHistory || []);
        } else {
          setError('No subscription data found');
        }
      } else {
        setError(response?.data?.message || response?.problem || 'Failed to fetch subscription details');
      }
    } catch (err) {
      console.error('Error fetching subscription detail:', err);
      setError(err?.message || 'An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    subscription,
    billingHistory,
    loading,
    error,
    fetchSubscriptionDetail,
  };
}
